<p-multiSelect
  name="calendars"
  size="small"
  [options]="this.options"
  (onChange)="onChange($event)"
  [(ngModel)]="this.selected"
  [filter]="false"
  [showHeader]="false"
  optionLabel="name"
  fluid
></p-multiSelect>
